module.exports = __webpack_public_path__ + "static/media/fullscreen-live-img.b441cd4c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fullscreen-live-img.svg
// module id = 948
// module chunks = 0